import React from "react";
import SubDivisionForm from "./SubDivisionForm";

export default function SubDivisionEdit() {
  return <SubDivisionForm mode="edit" />;
}
